import { UserEntity } from '@thirsty-camel/hump-club/src/modules/user/user.entity'
import { State } from '../types/state'

export const getFormattedAddress = (address: UserEntity['address']): string | null => {
  if (!address) return null
  let string = `${address.line1} ${address.city}, ${address.state} ${address.postcode}`
  if (address.line2) string = `${address.line2}/${string}`
  return string
}

export const getStateForPostcode = (postcode: string): State => {
  const number = parseInt(postcode, 10)

  if (1000 <= number && number <= 1999) return State.NSW
  if (2000 <= number && number <= 2599) return State.NSW
  if (2619 <= number && number <= 2899) return State.NSW
  if (2921 <= number && number <= 2999) return State.NSW

  if (200 <= number && number <= 299) return State.ACT
  if (2600 <= number && number <= 2618) return State.ACT
  if (2900 <= number && number <= 2920) return State.ACT

  if (3000 <= number && number <= 3999) return State.VIC
  if (8000 <= number && number <= 8999) return State.VIC

  if (4000 <= number && number <= 4999) return State.QLD
  if (9000 <= number && number <= 9999) return State.QLD

  if (5000 <= number && number <= 5799) return State.SA
  if (5800 <= number && number <= 5999) return State.SA

  if (6000 <= number && number <= 6797) return State.WA
  if (6800 <= number && number <= 6999) return State.WA

  if (7000 <= number && number <= 7799) return State.TAS
  if (7800 <= number && number <= 7999) return State.TAS

  if (800 <= number && number <= 899) return State.NT
  if (900 <= number && number <= 999) return State.NT

  return null
}
